import * as React from "react";
const SvgFiRrBonusStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bonus-star_svg__a)">
      <path
        fill="#062147"
        d="M23 13c0 6.065-4.935 11-11 11S1 19.065 1 13a1 1 0 0 1 2 0c0 4.963 4.038 9 9 9s9-4.037 9-9a1 1 0 0 1 2 0m-8-1a3 3 0 0 1-.386 1.472A3 3 0 0 1 16 16c0 1.654-1.346 3-3 3h-2c-1.103 0-2-.897-2-2v-6c0-1.103.897-2 2-2h1c1.654 0 3 1.346 3 3m-4 1h1c.551 0 1-.449 1-1s-.449-1-1-1h-1zm3 3c0-.552-.449-1-1-1h-2v2h2c.551 0 1-.448 1-1M1.17 9.53a.67.67 0 0 0 1.021.753l1.305-.912 1.31.912c.227.158.528.16.758.005l.006-.004a.67.67 0 0 0 .26-.764l-.476-1.447 1.221-.853a.67.67 0 0 0 .266-.712l-.004-.014a.67.67 0 0 0-.65-.507H4.602l-.37-1.421a.755.755 0 0 0-1.463-.001L2.4 5.986H.802a.67.67 0 0 0-.65.51l-.006.02a.67.67 0 0 0 .268.71l1.22.849zM23.84 6.507l-.004-.014a.67.67 0 0 0-.65-.507h-1.585l-.37-1.421a.755.755 0 0 0-1.463-.001l-.37 1.421h-1.596a.67.67 0 0 0-.65.51l-.006.02a.67.67 0 0 0 .268.71l1.22.849-.466 1.456a.67.67 0 0 0 1.022.753l1.305-.912 1.31.912c.227.158.528.16.758.005l.006-.004a.67.67 0 0 0 .26-.764l-.476-1.447 1.221-.853a.67.67 0 0 0 .266-.713M8.915 3.225l1.22.849-.466 1.456a.67.67 0 0 0 1.022.753l1.305-.912 1.31.912c.227.158.528.16.758.005l.006-.004a.67.67 0 0 0 .26-.764l-.476-1.447 1.221-.853a.67.67 0 0 0 .266-.712l-.004-.014a.67.67 0 0 0-.65-.507h-1.585l-.37-1.421a.755.755 0 0 0-1.463-.001l-.37 1.421H9.302a.67.67 0 0 0-.65.51l-.006.02a.67.67 0 0 0 .268.71z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bonus-star_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBonusStar;
